import { defineMessages } from 'react-intl';

export const messages: {
	filterByAppsButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	chatModeMenuTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	webSearchToggleTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	orgKnowledgeToggleTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	reasoningSectionTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sourcesSectionTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	rovoAutoReasoningToggleTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	rovoAutoReasoningToggleDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	thinkDeeperToggleTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	thinkDeeperToggleDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	thinkDeeperDisabledDueToAgentsTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	deepResearchToggleTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	deepResearchToggleDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	autoApplyToggleTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	autoApplyDisabledTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	searchAppsPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	searchDisabledDueToAgentsTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	drDisabledDueToAgentsTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	filterByAppsButtonLabel: {
		id: 'ai-mate.chat-input.mode.menu.filter-by-apps.label',
		defaultMessage: 'Filter by apps',
		description: 'Label for the filter by apps button',
	},
	chatModeMenuTooltip: {
		id: 'ai-mate.chat-input.mode.menu.tooltip',
		defaultMessage: 'Customize',
		description: 'Tooltip for the chat mode menu',
	},
	webSearchToggleTitle: {
		id: 'ai-mate.chat-input.mode.menu.web-search.title',
		defaultMessage: 'Include web results',
		description: 'The title of the web search toggle',
	},
	orgKnowledgeToggleTitle: {
		id: 'ai-mate.chat-input.mode.menu.org-knowledge.title',
		defaultMessage: 'Search company knowledge',
		description: 'The title of the organizational knowledge toggle',
	},
	reasoningSectionTitle: {
		id: 'ai-mate.chat-input.mode.menu.reasoning.section.title',
		defaultMessage: 'Reasoning',
		description: 'The title of the reasoning section',
	},
	sourcesSectionTitle: {
		id: 'ai-mate.chat-input.mode.menu.sources.section.title',
		defaultMessage: 'Sources',
		description: 'The title of the sources section',
	},
	rovoAutoReasoningToggleTitle: {
		id: 'ai-mate.chat-input.mode.menu.rovo-auto-reasoning.title',
		defaultMessage: 'Let Rovo decide',
		description: 'The title of the auto reasoning toggle',
	},
	rovoAutoReasoningToggleDescription: {
		id: 'ai-mate.chat-input.mode.menu.rovo-auto-reasoning.description',
		defaultMessage: 'Rovo picks the best reasoning',
		description: 'The description of the auto reasoning toggle',
	},
	thinkDeeperToggleTitle: {
		id: 'ai-mate.chat-input.mode.menu.think-deeper.title',
		defaultMessage: 'Think deeper',
		description: 'The title of the think deeper toggle',
	},
	thinkDeeperToggleDescription: {
		id: 'ai-mate.chat-input.mode.menu.think-deeper.description',
		defaultMessage: 'Longer thinking for robust responses',
		description: 'The description of the think deeper toggle',
	},
	thinkDeeperDisabledDueToAgentsTooltip: {
		id: 'ai-mate.chat-input.mode.menu.think-deeper.disabled.tooltip',
		defaultMessage: "For now, agents can't use think deeper.",
		description: 'Tooltip to show with disabled think deeper button when shown in Agent window',
	},
	deepResearchToggleTitle: {
		id: 'ai-mate.chat-input.mode.menu.deep-research.title',
		defaultMessage: 'Deep research',
		description: 'The title of the deep research toggle',
	},
	deepResearchToggleDescription: {
		id: 'ai-mate.chat-input.mode.menu.deep-research.description',
		defaultMessage: 'Synthesize insights and create reports',
		description: 'The description of the deep research toggle',
	},
	autoApplyToggleTitle: {
		id: 'ai-mate.chat-input.mode.menu.auto-apply.title',
		defaultMessage: 'Auto-apply AI writing changes',
		description: 'Title for the auto-apply toggle in the chat mode menu',
	},
	autoApplyDisabledTooltip: {
		id: 'ai-mate.chat-input.mode.menu.auto-apply.disabled.tooltip',
		defaultMessage: 'Auto-apply is not available in this context',
		description: 'Tooltip shown when auto-apply toggle is disabled',
	},
	searchAppsPlaceholder: {
		id: 'ai-mate.chat-input.mode.menu.search-apps.placeholder',
		defaultMessage: 'Search apps',
		description: 'The placeholder of the search input',
	},
	searchDisabledDueToAgentsTooltip: {
		id: 'ai-mate.chat-input.mode.menu.search.disabled.tooltip',
		defaultMessage: "For now, agents can't use web search.",
		description: 'Tooltip to show with disabled search button when shown in Agent window',
	},
	drDisabledDueToAgentsTooltip: {
		id: 'ai-mate.chat-input.mode.menu.dr.disabled.tooltip',
		defaultMessage: "For now, agents can't use deep research.",
		description: 'Tooltip to show with disabled DR button when shown in Agent window',
	},
});
